import { Link as RouterLink } from 'react-router-dom';
import { s } from '@/theme/tokens';
import { Stack } from '@/ui';
import { Box, Button, Text } from '@/ui/primitives';
import { landingCopy } from './landingCopy';
import { landingSpacing } from './landingSpacing';
import type { ReactElement } from 'react';

type LandingHeroSectionProps = {
  headerWidth: number;
};

export const LandingHeroSection = ({ headerWidth }: LandingHeroSectionProps): ReactElement => (
  <Box
    component="section"
    sx={{
      position: 'relative',
      py: s('lg'),
    }}
  >
    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <Box
        sx={{
          maxWidth: headerWidth,
          mx: 'auto',
          pt: landingSpacing.hero.paddingTop,
          pb: landingSpacing.hero.paddingBottom,
          px: s('none'),
        }}
      >
        <Stack gap="xl">
          <Text
            role="brand"
            component="h1"
            transform="none"
            sx={(theme) => ({
              lineHeight: 1.25,
              fontWeight: 600,
              fontFamily: theme.typography.mono.fontFamily,
              fontSize: theme.typography.h3.fontSize,
              ml: s('none'),
            })}
          >
            {landingCopy.hero.brand}
          </Text>
          <Text role="pageTitle" component="h2" transform="none">
            {landingCopy.hero.headline}
          </Text>
          <Text
            role="bodyMuted"
            component="p"
            mb="md"
            sx={(theme) => ({ fontSize: theme.typography.h5.fontSize })}
          >
            {landingCopy.hero.subheading}
          </Text>
          <Box sx={{ mt: `-${s('md')}` }}>
            <Button variant="primary" component={RouterLink} to="/sign-up">
              {landingCopy.hero.primaryCta}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  </Box>
);
